var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"facebook",on:{"click":_vm.logInWithFacebook}},[_vm._v(" Accedi con Facebook ")])
}
var staticRenderFns = []

export { render, staticRenderFns }